var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"shadow-card rounded-card px-e18 pt-e20 pb-e28 s:py-e25 s:px-e32 bg-white relative"},'div',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }